<template>
  <div class="content-section content-section-first" v-if="config && config.nodes">
    <div class="layout">
      <div class="content-section-inner clearfix">
        <div
          class="content-section-item animatedParent animateOnce"
          v-for="(item,index) in config.nodes"
          :key="index"
        >
          <div class="c-text-image c-text-image–-third animated fadeIn delay-500 go">
            <a href="javascript:void(0);" @click="actionHandler(item.action)" class="c-text-image__visual GTM-lp-perfume-1-visual">
              <picture class="c-text-image__visual-container">
                <img class="c-text-image__item lazyloaded" :alt="item.title" :src="item.src" />
              </picture>
            </a>
            <div class="c-text-image__content">
              <div class="c-text-image__text">
                <div class="c-text-image__title heading-h4" style="color:#000000">{{item.title}}</div>
                <div class="c-text-image__description" style="color:#575757">{{item.desc}}</div>
                <div class="c-text-image__link" style="color:#000000" v-if="item.button">
                  <a href="javascript:void(0);" @click="actionHandler(item.action)" class="link-with-arrow GTM-lp-perfume-1-CTA">{{item.button}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import actionMixins from '@/utils/action.mixins';

export default {
  name: "ImageFlexUnlimited",
  mixins: [actionMixins],
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      nodes: []
    };
  }
};
</script>
<style lang="scss" scoped>
.content-section {
  padding: 0 0.9375rem;
  margin: 5rem 0;
}
.content-section-first {
  // margin: 8.75rem 0 3.375rem;
  margin: 3rem 0 3.375rem;
  .content-section-item {
    &:first-child { width: 100%; text-align: center; }
    &:nth-child(2) { width: 13.9375rem; margin-left: auto; }
    &:nth-child(3), &:nth-child(5) { width: 15.9375rem; }
    &:nth-child(4) { width: 100%; text-align: center; }
    .c-text-image, .c-text-image__visual, .c-text-image__item { width: 100%; }
    .c-text-image__visual { position: relative; display: inline-block; }
    .c-text-image--third { display: inline-block; }
    .c-text-image__content {
      display: flex;
      .c-text-image__text { flex-grow: 1; width: 0; text-align: left; }
    }
    .c-text-image__title {
      text-align: center;
      font-size: 1.5625rem;
      padding: 0;
      margin: 1rem 0 0.3125rem;
      font-family: PlayfairDisplay-Regular, arial, sans-serif;
    }
    .c-text-image__description {
      text-align: center;
      font-size: 0.8125rem;
      line-height: 1.3125rem;
      color: #575757;
      font-family: HelveticaNeueLTW05-45Light, arial, sans-serif;
      padding-top: 0;
    }
    .c-text-image__link { text-align: center; margin-top: 0.75rem; padding: 0; }
    .link-with-arrow {
      position: relative; cursor: pointer; text-decoration: underline;
      &:hover { color: #c4926d; text-decoration: none; }
    }
  }
  .content-section-item + .content-section-item { margin-top: 5rem; }
}
@media screen and (min-width: 768px) {
  .content-section { padding: 0 3.125rem; }
  .content-section-first {
    // margin: 9.375rem 0 7rem;
    margin: 3rem 0 7rem;
    .content-section-item {
      &:first-child { width: 31.0625rem; text-align: left; }
      &:nth-child(2) { width: 23.875rem; }
      &:nth-child(3), &:nth-child(5) { width: 20.3125rem; }
      &:nth-child(4) { width: 27.5rem; margin-left: auto; margin-right: auto; }
    }
  }
}

@media screen and (min-width: 1024px) {
  .content-section { margin: 6.25rem 0; }
  .content-section-first {
    // margin: 9.375rem 0 8.375rem;
    margin: 3rem 0 8.375rem;
    .content-section-item {
      float: left;
      &:first-child { width: 43.1875rem; }
      &:nth-child(2) { width: 23.875rem; float: right; margin-left: 7.375rem; margin-top: 24.25rem; }
      &:nth-child(3), &:nth-child(5) { width: 24.25rem; }
      &:nth-child(4) { text-align: left; margin-left: 13.625rem; width: 30.5625rem; }
      .c-text-image–-third {
        .c-text-image__item {
          transition: all 0.3s; max-width: 100%;
          &:hover { transform: scale(1.2); }
        }
        .c-text-image__visual-container { display: block; overflow: hidden; }
      }
    }
  }
  .fadeIn.go { animation-name: fadeIn; }
  .content-section-item + .content-section-item { margin-top: 6.25rem; }
}
@media screen and (min-width: 1200px) {
  .content-section { padding: 0; }
  .content-section-first {
    .content-section-item {
      &:nth-child(5) { margin-top: -10rem; }
    }
  }
}
</style>